import type { RefData } from '@wix/thunderbolt-becky-root'
import { pointers, ViewMode, QueryProperty, Component } from '@wix/thunderbolt-becky-types'
import { ID_SEPARATOR, MOBILE_PROPERTY_SUFFIX } from './byRefsis/constants'
import _ from 'lodash'

const DATA_MAPS = pointers.data.DATA_MAPS
const PROPERTY_TYPES = pointers.components.PROPERTY_TYPES

export {
	REF_DELIMITER,
	getUniqueId,
	getRefCompIdFromInflatedId,
	getMultipleRefCompsIdFromInflatedId,
	getTemplateFromInflatedId,
} from '@wix/thunderbolt-commons'

export const getEmptyDataMaps: () => RefData = () => ({
	[DATA_MAPS.BEHAVIORS]: {},
	[DATA_MAPS.BREAKPOINTS]: {},
	[DATA_MAPS.PROPERTIES]: {},
	[DATA_MAPS.CONNECTIONS]: {},
	[DATA_MAPS.DESIGN]: {},
	[DATA_MAPS.CURSOR]: {},
	[DATA_MAPS.DATA]: {},
	[DATA_MAPS.LAYOUT]: {},
	[DATA_MAPS.MOBILE_HINTS]: {},
	[DATA_MAPS.STYLE]: {},
	[DATA_MAPS.TRANSFORMATIONS]: {},
	[DATA_MAPS.TRANSITIONS]: {},
	[DATA_MAPS.ANCHOR]: {},
	[DATA_MAPS.VARIANTS]: {},
	[DATA_MAPS.REACTIONS]: {},
	[DATA_MAPS.TRIGGERS]: {},
	[DATA_MAPS.SLOTS]: {},
	[DATA_MAPS.PRESETS]: {},
	[DATA_MAPS.VARIABLES]: {},
	[DATA_MAPS.PATTERNS]: {},
	[DATA_MAPS.EFFECTS]: {},
	[DATA_MAPS.CLASSNAMES]: {},
	[DATA_MAPS.STATES]: {},
	[DATA_MAPS.INNER_ELEMENTS]: {},
	[DATA_MAPS.INTENT]: {},
})

export const DATA_QUERIES_TO_INFLATE = [
	PROPERTY_TYPES.BEHAVIOR_QUERY,
	PROPERTY_TYPES.BREAKPOINTS_QUERY,
	PROPERTY_TYPES.PROPERTY_QUERY,
	PROPERTY_TYPES.DESIGN_QUERY,
	PROPERTY_TYPES.DATA_QUERY,
	PROPERTY_TYPES.LAYOUT_QUERY,
	PROPERTY_TYPES.MOBILE_HINTS_QUERY,
	PROPERTY_TYPES.STYLE_ID,
	PROPERTY_TYPES.TRANSFORMATION_QUERY,
	PROPERTY_TYPES.TRANSITION_QUERY,
	PROPERTY_TYPES.PRESETS_QUERY, // TODO: under ByRefV2 experiment
	PROPERTY_TYPES.SLOTS_QUERY,
	PROPERTY_TYPES.VARIABLES_QUERY,
	PROPERTY_TYPES.VARIANTS_QUERY,
	PROPERTY_TYPES.STATES_QUERY,
	PROPERTY_TYPES.CLASSNAMES_QUERY,
	PROPERTY_TYPES.TRIGGERS_QUERY,
	PROPERTY_TYPES.REACTION_QUERY,
	PROPERTY_TYPES.PATTERNS_QUERY,
	PROPERTY_TYPES.EFFECTS_QUERY,
	PROPERTY_TYPES.CONNECTION_QUERY,
]

export const removeHash = (value: string) => value && value.replace('#', '')

const isMobile = (viewMode: ViewMode) => viewMode === 'mobile'

export const isMobileProperty = (currentViewMode: ViewMode, dataQueryName: QueryProperty) =>
	isMobile(currentViewMode) && dataQueryName === PROPERTY_TYPES.PROPERTY_QUERY

export const getUniqueDataQuery = (id: string, suffix: string, withMobileSuffix?: boolean) =>
	`${id}${ID_SEPARATOR}${suffix}${withMobileSuffix ? `${MOBILE_PROPERTY_SUFFIX}` : ''}`

export const sharedPartWidgetId = (pageId: string, rootCompId?: string) =>
	`${pageId}${rootCompId ? `_${rootCompId}` : ''}`

export const fixBuilderWidgetComp = (comp: Component) => {
	const fixedComp = _.cloneDeep(comp)
	const [appDefinitionId, widgetId] = comp.builderType!.split('.')[2].split('_')
	_.set(fixedComp, 'componentType', 'RefComponent')
	_.set(fixedComp, 'type', 'RefComponent')
	_.set(fixedComp, 'dataQuery', `dataItem-${comp.id}`)
	const compDataItem = {
		type: 'WidgetRef',
		id: `dataItem-${comp.id}`,
		isBuilderComponent: true,
		appDefinitionId,
		widgetId,
	}
	return { fixedComp, compDataItem }
}
